import { render } from "./BottleIcon.vue?vue&type=template&id=7ea38926"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/BottleIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ea38926"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ea38926', __exports__)) {
    api.reload('7ea38926', __exports__)
  }
  
  module.hot.accept("./BottleIcon.vue?vue&type=template&id=7ea38926", () => {
    api.rerender('7ea38926', render)
  })

}


export default __exports__